import { useMutation } from '@apollo/client/react';
import { MARK_ORDER_LABEL_PRINTED_MUTATION } from './useMarkOrderLabelPrintedMutation.gql';
export const useMarkOrderLabelPrintedMutation = () => {
  return useMutation(MARK_ORDER_LABEL_PRINTED_MUTATION);
};
